<template>
  <div class="family" v-title data-title="广东多对多物联集团股份有限公司">
    <!-- 		<div class="topCont container">
			<div class="familyBox">
				<div>
					<p class="title">多对多智慧康养百城千盘</p>
					<p class="title_p">全国招募火热进行中</p>
				</div>
				<div class="line"></div>
			</div>
		</div>
		
		<div>
			<div class="analysis">
				<div class="analysis_left">
					<p>数据预测，2050年我国</p>
					<p>60岁及以上老年人口</p>
					<p>将达<span>4.83亿</span>人</p>
					<p>老年人口总消费<span>62.26万亿</span>元</p>
					<p>数据统计，<span>90%</span>左右老人</p>
					<p>选择居家养老</p>
					<p class="p_end">机会就在眼前</p>
				</div>
				<div class="analysis_img">
					<img src="~img/family/chart1.png" alt="">
				</div>
				<div class="analysis_right">
					<div>
						<p class="p1"></p>
						<p class="p2">90%</p>
						<p class="p3">居家养老</p>
					</div>
					<div>
						<p class="p1"></p>
						<p class="p2">7%</p>
						<p class="p3">社区养老</p>
					</div>
					<div>
						<p class="p4"></p>
						<p class="p2">3%</p>
						<p class="p3">机构养老</p>
					</div>
				</div>
			</div>
		</div> -->

    <div class="ju_jia">
      <div class="div2_title">
        <p class="p1">多对多居家康养数字化解决方案</p>
        <p class="line"></p>
      </div>
      <div class="min_title">
        <p>“时光冉冉，长大后，我们才知道父母的不容易......</p>
        <p>孝常在，笑常伴，您养我长大，我陪您到老......”</p>
      </div>
      <div class="ju_jia_img">
        <img src="~img/family/jujiaimg.png" alt="" />
      </div>
    </div>

    <div class="many_interaction">
      <p>多屏互动，操作简单，老人爱用。</p>
      <p class="line"></p>
    </div>

    <div class="number_raise_old">
      <div class="number_raise_old_title">
        <p>多对多居家康养数字化共享新方式</p>
        <p class="line"></p>
      </div>
      <div class="number_raise_old_list">
        <ul class="top">
          <li>
            <img src="~img/family/numberraise1.png" alt="" />
            <h3>数字居家健康</h3>
            <p>
              联动社区及康养机构，实现慢性病及睡眠健康等居家管理，监护与预警，健康数据与家人及
              签约顾问同步共享，多方式获取饮食，运动，睡眠，食物等方面健康指导......
            </p>
          </li>
          <li>
            <img src="~img/family/numberraise2.png" alt="" />
            <h3>数字居家平安</h3>
            <p>
              联动社区及康养机构，实现24小时在线安全监护与预警，防漏水漏气漏电及陌生人入侵带来
              的安全隐患，紧急意外一句/一键呼援，家人/物业/社区签约机构联动处理，安全更安心。
            </p>
          </li>
          <li>
            <img src="~img/family/numberraise3.png" alt="" />
            <h3>数字有趣生活</h3>
            <p>
              创新多屏互动方式，语音控制生活所需，简单好用，老朋友的约会，即使远在千里，也能见屏
              如见面;家政等周边商业与服务，一触既达，安全又便捷
            </p>
          </li>
        </ul>
      </div>
      <div class="duoduo">
        <div class="textCont">
          <div class="left">
            <img class="left_img" src="~img/family/raisecore1.png" alt="" />
          </div>
          <div class="right">
            <div class="rightCont">
              <h3 class="title">联动数字康养中心</h3>
              <div class="line"></div>
              <p>
                全纬度呵护，实现医养护一体化综合服务，实现数字康养中心人车安全有序，联防联控，与居家养老
                实现全天候互联互动一体化，数字康养资源共享。给老年人更多的关爱与呵护。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="valid_solve">
      <div class="valid_solve_title">
        <p>多对多居家康养数字化有效解决</p>
        <p class="line"></p>
      </div>
      <div class="valid_solve_content">
        <ul>
          <li>
            <img src="~img/family/solve1.png" alt="" />
            <p>年轻人疲于生计<br />难以细致照顾老人</p>
          </li>
          <li>
            <img src="~img/family/solve2.png" alt="" />
            <p>独居老人<br />健康安全没保障</p>
          </li>
          <li>
            <img src="~img/family/solve3.png" alt="" />
            <p>紧急意外<br />无法有效呼援</p>
          </li>
          <li>
            <img src="~img/family/solve4.png" alt="" />
            <p>慢病管理难<br />小病看病难</p>
          </li>
          <li>
            <img src="~img/family/solve5.png" alt="" />
            <p>漏水漏电漏气存在<br />安全隐患等居家难题</p>
          </li>
          <li>
            <img src="~img/family/solve6.png" alt="" />
            <p>有效避免人为或非人为<br />造成的家庭悲剧......</p>
          </li>
        </ul>
      </div>
      <div class="valid_solve_cend">
        <p>随时随地关爱老人，关心家人，让年轻人更放心。</p>
      </div>
    </div>

    <div class="cend_shadow"></div>

    <!-- <div class="duoduo">
			<div class="duoduoBox container">
				<div class="textCont row">
					<div class="left col-sm-6">
						<img src="~img/family/duoduoBg.png" alt="" width="100%">
					</div>
					<div class="right col-sm-6">
						<div class="rightCont">
							<h3 class="title">创新研发语音中控机器人”多多智慧管家”</h3>
							<div class="line"></div>
							<ul>
								<li>控制全屋智能产品，跨品牌、跨品类，物联无壁垒。</li>
								<li>在家语音，释放双手；在外APP，远程安全。</li>
								<li>2018年12月获得粤港物联网大赛“最佳物联网创意奖”</li>
								<li>连接智慧小区-连接智慧社区-连接周边商业。</li>
							</ul>
						</div>
					</div>

				</div>
			</div>
		</div>

		<div class="duoduoIntro container-fluid">
			<div class="container">
				<div class="item row">
					<div class="left col-sm-6">
						<div class="lfBox">
							<h3>一个系统满足<br>多品牌多产品物联</h3>
							<p>避免不同品牌产品无法物联的尴尬！</p>
							<p class="btText">多对多物联平台已吸引400多个知名专业品牌入驻，联接智能产品数超2000款。</p>
						</div>
					</div>
					<div class="right col-sm-6">
						<ul>
							<li>照明设备</li>
							<li>红外设备</li>
							<li>电机设备</li>
							<li>能源设备</li>
							<li>健康设备</li>
							<li>睡眠设备</li>
							<li>安防设备</li>
							<li>环境设备</li>
							<li>智能卫浴</li>
							<li>智能家电</li>
							<li>智能家具</li>
							<li>智能门锁</li>
						</ul>
					</div>
				</div>
				<div class="item center row">
					<div class="left col-sm-6">
						<div class="lfBox">
							<h3>一个系统满足<br>多功能应用交互</h3>
							<p>避免多个系统孤岛给生活造成的不便及烦恼！</p>
						</div>
					</div>
					<div class="right col-sm-6">
						<ul>
							<li>
								<div class="title">照明设备</div>
								<div class="text">
									App&语音<br>
									一键控制<br>
									智能互联<br>
								</div>
							</li>
							<li>
								<div class="title">智慧用电</div>
								<div class="text">
									统计<br>
									安全<br>
									控制<br>
								</div>
							</li>
							<li>
								<div class="title">智慧健康</div>
								<div class="text">
									健康知识<br>
									识别食物&运动<br>
									检测&数据<br>
								</div>
							</li>
							<li>
								<div class="title">智慧睡眠</div>
								<div class="text">
									睡眠监测<br>
									睡眠报告<br>
								</div>
							</li>
							<li>
								<div class="title">智能安防</div>
								<div class="text">
									传感<br>
									报警<br>
									通知<br>
								</div>
							</li>
							<li>
								<div class="title">环境管理</div>
								<div class="text">
									数据采集<br>
									算法<br>
									实时数据<br>
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div class="item row">
					<div class="left col-sm-6">
						<div class="lfBox">
							<h3>一个系统满足<br>多元化服务</h3>
							<p>为您及家人的生活创造更多便利与幸福！</p>
						</div>
					</div>
					<div class="right col-sm-6">
						<ul>
							<li>视频通话</li>
							<li>公共监控</li>
							<li>智慧共享</li>
							<li>智慧物业</li>
							<li>智慧书屋</li>
							<li>智能预约</li>
							<li>社区服务</li>
							<li>智慧健康</li>
							<li>周边购物</li>
							<li>周边服务</li>
							<li>你能想到的</li>
							<li>意想不到的</li>
						</ul>
					</div>
				</div>
			</div>

		</div> -->
  </div>
</template>

<script>
export default {
  name: "family",
  metaInfo: {
    meta: [
      {
        name: "keywords",
        content:
          "多对多物联集团、银发经济、人口老龄化、心脑血管、慢性疾病、血压高、血糖、体脂管理、中医馆、养生馆、健康管理师、科学工作站、公益行动、老年产品目录、健康机构、客户管理、拓客、医保社保、养生保健、远程管理",
      },
      {
        name: "discription",
        content:
          "多对多物联集团是一家深耕于大健康领域多年的健康管理数智服务商，是华为战略合作伙伴，华为健康数据与多对多实现互联互通。多对多健康管理 SaaS 系统和健康管理拓客赢利AI解决方案，为用户建立健康档案，提供健康 AI 管理。业务涵盖医院、养老机构、社区中心、康养中心、养老院、中医馆、养生馆等。针对人口老龄化现状和银发经济趋势，多对多加入了科学健康指导工作站，百城千镇家庭防大病数智服务健康公益行动办公室。开放专业健康管理师进驻，实现合作加盟共赢。",
      },
    ],
  },
};
</script>

<style scoped lang="less">
.bottom {
  box-shadow: none !important;
}

.line {
  height: 2px;
  width: 50px;
  background: #ee7b1d;
  margin: 20px auto 10px;
}

.family {
  width: 100%;
  .topCont {
    padding-bottom: 40px;
    text-align: center;

    .familyBox {
      .title {
        text-align: center;
        padding-top: 80px;
      }

      .title_p {
        color: #ee7b1d;
        text-align: center;
      }

      .line {
        height: 2px;
        width: 50px;
        background: #ee7b1d;
        margin: 20px auto 10px;
      }

      p {
        font-size: 18px;
        margin-bottom: 0;
        font-weight: bold;
      }
    }
  }

  .analysis {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 60px;
    @media (max-width: 576px) {
      padding: 0 10px;
    }
    .analysis_left {
      width: 200px;
      @media (max-width: 576px) {
        width: 170px;
      }
      p {
        font-size: 14px;
        color: #333;
        line-height: 24px;
        margin: 0;
        padding: 0;
        span {
          color: #ee8835;
        }
      }
      @media (max-width: 576px) {
        p {
          line-height: 17px;
        }
      }
      .p_end {
        font-size: 18px;
        font-weight: bold;
        color: #ee8835;
      }
    }
    .analysis_img {
      // margin: 0 60px;
      img {
        width: 202px;
        height: 202px;
        background-size: 100% 100%;
      }
      @media (max-width: 576px) {
        img {
          width: 100px;
          height: 100px;
          background-size: 100% 100%;
        }
      }
    }
    .analysis_right {
      width: 200px;
      padding-left: 26px;
      div {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 42px;
        p {
          font-size: 14px;
          color: #333;
        }
        .p1 {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background-color: #ee8835;
        }
        .p2 {
          margin-left: 10px;
        }
        .p3 {
          margin-left: 16px;
        }
        .p4 {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background-color: #0989c9;
        }
      }
    }
  }

  .ju_jia {
    text-align: center;
    margin-top: 50px;
    .div2_title {
      .p1 {
        font-size: 28px;
        color: #000;
        font-weight: bold;
      }
    }
    .min_title {
      text-align: center;
      p {
        font-size: 16px;
        color: #ccc;
        line-height: 22px;
        margin: 0;
      }
    }
    .ju_jia_img {
      margin: 30px 0 130px;
      @media (max-width: 576px) {
        margin: 30px auto 50px;
      }
    }
    @media (max-width: 576px) {
      .ju_jia_img {
        img {
          width: 90%;
        }
      }
    }
  }

  .many_interaction {
    background-image: url("../../assets/images/family/interaction.png");
    background-size: 100% 100%;
    margin: 0 auto 120px;
    width: 1080px;
    height: 512px;
    text-align: center;
    @media (max-width: 576px) {
      width: 90%;
      height: 260px;
      margin: 0 auto 40px;
    }
    p {
      font-size: 28px;
      color: #000;
      font-weight: bold;
    }
  }

  .number_raise_old {
    .number_raise_old_title {
      text-align: center;
      p {
        font-size: 28px;
        color: #000;
        font-weight: bold;
      }
    }
    .number_raise_old_list {
      margin-top: 50px;
      ul {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        box-sizing: border-box;
        width: 1200px;
        margin: 0 auto;
        @media (max-width: 576px) {
          width: 100%;
        }
        // &.top{
        //   @media (max-width: 768px){
        //     max-width: 690px;
        //   }
        // }
        li {
          text-align: center;
          width: 375px;
          border: 1px solid #eeeeff;
          margin: 0 10px;
          box-shadow: 0 -4px 10px -3px #eeeeff;
          margin-bottom: 20px;
          @media (max-width: 1200px) {
            width: 300px;
          }
          @media (max-width: 576px) {
            margin-bottom: 20px;
          }
          img {
            width: 375px;
            height: 225px;
            background-size: 100% 100%;
            @media (max-width: 1200px) {
              width: 300px;
            }
          }
          h3 {
            color: #ee8835;
            font-size: 24px;
            margin-top: 34px;
          }
          p {
            font-size: 16px;
            color: #736f73;
            line-height: 22px;
            padding: 20px 46px 40px;
          }
        }
      }
    }

    .duoduo {
      margin: 50px auto 30px;
      border: 1px solid #eeeeff;
      box-shadow: 0 -4px 10px -3px #eeeeff;
      width: 1230px;
      @media (max-width: 576px) {
        width: 90%;
        border: none;
        box-shadow: 0 -4px 10px -3px #fff;
      }
      .textCont {
        display: flex;
        justify-content: space-between;
        align-items: center;
        @media (max-width: 576px) {
          flex-wrap: wrap;
        }
        .left {
          .left_img {
            @media (max-width: 576px) {
              width: 100%;
            }
          }
        }
        .right {
          padding: 100px;
          @media (max-width: 576px) {
            width: 100%;
            padding: 20px;
          }
          .rightCont {
            .title {
              @media (min-width: 768px) {
                font-size: 28px;
              }

              @media (max-width: 768px) {
                font-size: 18px;
                line-height: 30px;
              }
            }
            .line {
              width: 40px;
              height: 2px;
              margin: 20px 0;
              background: #ee7b1d;
            }
            p {
              font-size: 18px;
              color: #333;
              line-height: 30px;
            }
            @media (max-width: 576px) {
              width: 90%;
            }
          }
        }
      }
    }
  }

  .valid_solve {
    box-shadow: 0 -10px 10px -3px #ffeeee;
    margin-top: 100px;
    .valid_solve_title {
      padding-top: 50px;
      p {
        font-size: 28px;
        color: #000;
        font-weight: bold;
        text-align: center;
      }
    }
    .valid_solve_content {
      margin-top: 50px;
      ul {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        @media (max-width: 576px) {
          justify-content: space-around;
        }
        li {
          width: 200px;
          margin: 0 5px;
          box-shadow: 0 -4px 10px -3px #eeeeff;
          position: relative;
          @media (max-width: 576px) {
            width: 180px;
            margin-bottom: 20px;
          }
          img {
            width: 200px;
            height: 156px;
            background-size: 100% 100%;
            @media (max-width: 576px) {
              width: 180px;
            }
          }

          p {
            padding: 36px 10px;
            color: #fff;
            font-size: 16px;
            font-weight: bold;
            background-color: #ee8835;
            text-align: center;
          }
        }
        li::after {
          position: absolute;
          content: "";
          bottom: 6px;
          right: 90px;
          border: 10px solid;
          border-color: transparent transparent #ee8835 #ee8835;
          transform: rotate(-45deg);
          opacity: 0.8;
          @media (max-width: 576px) {
            right: 80px;
          }
        }
      }
    }
    .valid_solve_cend {
      padding: 80px 0;
      font-size: 22px;
      color: #89898c;
      text-align: center;
      @media (max-width: 576px) {
        padding: 40px 0;
      }
    }
  }

  .cend_shadow {
    box-shadow: 0 -10px 10px -3px #ffeeee;
    height: 4px;
    padding: 10px 0;
    // border: 1px solid red;
  }

  .duoduoIntro {
    h3 {
      font-weight: bold;
    }

    background: linear-gradient(left, #ee7b1d, #f6af5a);
    padding-top: 80px;

    @media (max-width: 576px) {
      padding-top: 40px;
    }

    .item {
      color: #fff;
      padding-bottom: 80px;
      display: flex;
      justify-content: space-between;

      .left {
        padding-top: 20px;
        display: flex;
        align-items: center;

        h2 {
          line-height: 50px;
          padding-bottom: 20px;
        }

        .btText {
          padding-top: 40px;
        }
      }

      .right {
        padding-top: 20px;

        ul {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;

          li {
            font-size: 18px;
            width: 22%;
            line-height: 80px;
            color: #ee7b1d;
            background: #ffffff;
            text-align: center;
            margin-bottom: 14px;
            border-radius: 5px;

            @media (max-width: 992px) {
              width: 30%;
            }

            @media (max-width: 768px) {
              width: 40%;
            }

            &:hover {
              background: #ee7b1d;
              color: #fff;

              .text {
                color: #fff;
              }
            }
          }
        }
      }

      &.center {
        ul {
          li {
            width: 30%;

            @media (max-width: 992px) {
              width: 46%;
            }

            line-height: 35px;
            padding: 10px 0;

            .title {
              font-size: 20px;
            }

            .text {
              color: #333;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/family/family.vue